export default __webpack_public_path__ + "static/do-overflow-48827aed600c124ef8a9c22ca4a62308.png";